export const isValidEmail = (email) => {
  return email.match(
    /^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-z0-9]{1}[a-z0-9\-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$/i
  )
}

export const normalizeEmail = (email) => (typeof email === 'string' ? email.trim().toLowerCase() : email)

// The gender choices are M, F, NB (non-binary), O (Other), X (prefer no answer), or a pronoun (S, H, T)
export const genderMap = {
  Male: 'M',
  Female: 'F',
  'Non-binary': 'NB',
  Other: 'O',
  'Prefer not to answer': 'X',
  'she/her': 'S',
  'he/him': 'H',
  'they/them': 'T',
}
export const reverseGenderMap = Object.fromEntries(Object.entries(genderMap).map(([k, v]) => [v, k]))

const DEFAULT_GENDER_LABEL = 'Gender'
const DEFAULT_GENDER_OPTIONS = ['Female', 'Male', 'Non-binary', 'Other', 'Prefer not to answer']

export const getGenderDropdownConfig = (siteConfig) => {
  const label = siteConfig.features?.genderLabel || DEFAULT_GENDER_LABEL
  const options = siteConfig.features?.genderOptions || DEFAULT_GENDER_OPTIONS
  return {
    label: `${label}${siteConfig.features?.genderIsOptionalInProfiles ? ' (Optional)' : ''}`,
    options,
  }
}

export const raceMap = {
  'American Indian or Alaskan Native': 'native',
  Asian: 'asian',
  'Black or African American': 'black',
  'Hispanic or Latino': 'hispanic',
  'Native Hawaiian or Pacific Islander': 'pacific',
  White: 'white',
  'Bi-racial/Multi-racial': 'biracial',
  'Prefer not to answer': 'noanswer',
}
export const reverseRaceMap = Object.fromEntries(Object.entries(raceMap).map(([k, v]) => [v, k]))

export const censusRaceCategories = Object.keys(raceMap)

export const getCensusRaceCategories = (siteConfig) => {
  const excluded = siteConfig.features?.censusRaceCategoriesExclude || []
  return censusRaceCategories.filter((category) => !excluded.includes(category))
}

const DEFAULT_RACE_LABEL = 'Race'

export const getRaceLabel = (siteConfig) => {
  const label = siteConfig.features?.raceLabel || DEFAULT_RACE_LABEL
  return `${label}${siteConfig.features?.raceIsOptionalInProfiles ? ' (Optional)' : ''}`
}

export const divisionsSingularMap = {
  classes: 'Class',
  workshops: 'Workshop',
  excursions: 'Excursion',
}

const DEFAULT_MEMBER_PRICE_LABEL = '(members)'
const DEFAULT_NON_MEMBER_PRICE_LABEL = '(non-members)'

export const getMemberPriceLabel = (siteConfig) =>
  siteConfig.copy?.classes?.memberPriceLabel || DEFAULT_MEMBER_PRICE_LABEL

export const getNonMemberPriceLabel = (siteConfig) =>
  siteConfig.copy?.classes?.nonMemberPriceLabel || DEFAULT_NON_MEMBER_PRICE_LABEL

const getUdefDropdownConfig = (siteConfig, key) => {
  const label = siteConfig.features?.[`${key}Label`]
  const required = !!siteConfig.features?.[`${key}Required`]
  return {
    label: label ? `${label}${required ? '' : ' (optional)'}` : undefined,
    options: siteConfig.features?.[`${key}Options`],
    enabled: !!siteConfig.features?.[`${key}Enabled`],
    required,
  }
}

export const getUdef1DropdownConfig = (siteConfig) => getUdefDropdownConfig(siteConfig, 'udef1')

export const getUdef2DropdownConfig = (siteConfig) => getUdefDropdownConfig(siteConfig, 'udef2')

// features.seatsLeft: { mode: 'never' | 'threshold' | 'always', threshold?: number }
// Missing config means 'never'.
export const shouldShowSeatsLeft = (seatsAvailable, seatsLeft) => {
  if (!(seatsAvailable > 0)) return false
  switch (seatsLeft?.mode) {
    case 'always':
      return true
    case 'threshold':
      return seatsAvailable <= seatsLeft.threshold
    default:
      return false
  }
}

export const getSeatsLeftText = (siteConfig, spots) =>
  spots === 1
    ? `1 ${siteConfig.copy?.spotLeft || 'spot left'}`
    : `${spots} ${siteConfig.copy?.spotsLeft || 'spots left'}`
